import { render, staticRenderFns } from "./BlockDesktop.vue?vue&type=template&id=1d5f9577&"
import script from "./BlockDesktop.vue?vue&type=script&lang=js&"
export * from "./BlockDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports